module.exports = __webpack_public_path__ + "static/img/shi_pin_bai_huo.7e7462a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shi_pin_bai_huo.png
// module id = G7R+
// module chunks = 18